import React, { useContext } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
import { EnquiryContext } from 'venuescanner-js/react/components/Inbox/context/EnquiryContext';

import EnquiryFilter from 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryFilter';
import EnquirySort from 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquirySort';
import LeadsPanel from 'venuescanner-js/react/components/Inbox/components/Leads/LeadsPanel';
import MatchesPanel from 'venuescanner-js/react/components/Inbox/components/Matches/MatchesPanel';
import EnquiriesPanel from 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquiriesPanel';
import EnquirySearch from 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquirySearch';
import NewUserSplash from 'venuescanner-js/react/components/Inbox/components/Objects/NewUserSplash';
import EnquiryInfoSuggestedVenues from '../Enquiry/EnquiryInfoSuggestedVenues/EnquiryInfoSuggestedVenues';
import { authService } from 'venuescanner-js/services/auth';
import * as userType from 'venuescanner-js/constants/user_type';
import Loading from 'venuescanner-js/react/components/Inbox/components/Objects/Loading';
import NavigationBarToggle from './NavigationBarToggle';

const MAX_ENQUIRIES_FOR_SUGGESTION = 4;
const NavigationBar = () => {
  const { enquiriesLoading, threads, enquiriesAvailable, leadCounts } =
    useContext(EnquiryContext);
  const { activeThread, isMobileDevice, searchFilter, threadsFilter } =
    useContext(ViewContext);
  const location = useLocation();

  const shouldRenderEnquirySuggestion = (authUser, threads, maxEnquiries) => {
    return (
      authUser.user_type === userType.organiser &&
      threads.length > 0 &&
      threads.length < maxEnquiries
    );
  };
  const getNavigationBarItems = [
    {
      display: true,
      title: 'Enquiries',
      url: isMobileDevice
        ? '/inbox'
        : `/inbox/${activeThread?._subjects?._value?._id}`,
      disabled: false,
      value: 'enquiries',
    },
    {
      title: `MatchLeads ${`(${leadCounts?.leads})` || ''}`.trim(),
      url: '/inbox/leads',
      disabled: !leadCounts?.leads,
      display: authService?.user?.user_type === userType.host,
      value: 'matches',
    },
    {
      title: `Matches ${`(${leadCounts?.matches})` || ''}`.trim(),
      url: '/inbox/matches',
      disabled: !leadCounts?.matches,
      display: authService?.user?.user_type === userType.organiser,
      value: 'matches',
    },
  ];

  return (
    <div className='inbox__section navigation-bar'>
      <div className='navigation-bar__header'>
        <NavigationBarToggle
          active={
            location.pathname.includes('matches') ||
            location.pathname.includes('leads')
              ? 'matches'
              : 'enquiries'
          }
          items={getNavigationBarItems}
        />
      </div>

      <Switch>
        <Route exact path={['/inbox/matches', '/inbox/matches/:match_id']}>
          {!isMobileDevice && (
            <div className='navigation-bar__body'>
              <MatchesPanel />
            </div>
          )}
        </Route>
        <Route exact path={['/inbox/leads', '/inbox/leads/:lead_id']}>
          {!isMobileDevice && (
            <div className='navigation-bar__body'>
              <LeadsPanel />
            </div>
          )}
        </Route>
        <Route exact path={['/inbox/:thread_id/success']}>
          {!isMobileDevice && <></>}
        </Route>
        <Route path='/inbox'>
          <div className='navigation-bar__ctas'>
            <EnquiryFilter />
            <Box
              sx={{ display: 'flex', mb: 2.5 }}
              flexDirection={{ xs: 'column', sm: 'row' }}>
              <Box sx={{ flexGrow: 1 }}>
                <EnquirySearch />
              </Box>
              <Box sx={{ minWidth: 134, ml: 2 }}>
                <EnquirySort userType={authService.user.user_type} />
              </Box>
            </Box>
            {shouldRenderEnquirySuggestion(
              authService.user,
              threads,
              MAX_ENQUIRIES_FOR_SUGGESTION,
            ) && <EnquiryInfoSuggestedVenues firstThread={threads[0]} />}
          </div>
          <div className='navigation-bar__body'>
            {threads.length ? (
              <EnquiriesPanel
                enquiriesLoading={enquiriesLoading}
                enquiriesAvailable={enquiriesAvailable}
                threads={threads}
              />
            ) : (searchFilter !== null || threadsFilter) &&
              !enquiriesLoading ? (
              <div className='navigation-bar__list'>
                <p className='navigation-bar__no-search-results'>
                  No Enquiries found
                </p>
              </div>
            ) : enquiriesLoading ? (
              <Loading />
            ) : (
              <NewUserSplash />
            )}
          </div>
        </Route>
      </Switch>
    </div>
  );
};

export default NavigationBar;
